import type { ReactElement, ReactNode } from 'react';
import type { IconName } from '@/components/atoms/icon';
import { Icon } from '@/components/atoms/icon';
import { cn } from '@/lib/cn';

export type EmptyStateProps = {
  title: string;
  description?: string;
  icon?: IconName;
  action?: ReactNode;
  className?: string;
};

export function EmptyState({ title, description, icon, action, className }: EmptyStateProps): ReactElement {
  return (
    <div className={cn('flex-1 flex flex-col items-center justify-center text-center px-8 py-12', className)}>
      <div className="placeholder-stripe w-32 h-32 rounded-[var(--r-lg)] mb-6 flex items-center justify-center">
        {icon ? <Icon name={icon} size={40} className="text-[var(--ink-3)]" /> : null}
      </div>
      <h2 className="font-display text-[24px] font-semibold tracking-tight leading-tight text-[var(--ink)]">
        {title}
      </h2>
      {description && (
        <p className="text-[13px] text-[var(--ink-3)] mt-3 leading-relaxed max-w-[320px]">
          {description}
        </p>
      )}
      {action && <div className="mt-7 flex flex-col gap-2 w-full max-w-xs">{action}</div>}
    </div>
  );
}
